import { assign } from 'lodash';

import * as Canvas from '../ui/canvas';
import '../ui/plugin';

let { Cx } = window;

assign( Cx, Canvas );



/** WEBPACK FOOTER **
 ** ./src/web/canvas.js
 **/